import {
  Component,
  DoCheck,
  HostBinding,
  Input,
  DOCUMENT,
  inject
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Eq5QuestionV3 } from '../../../classes/question-eq5';
import { QuestionBaseV3ComponentDirective } from '../question-base.component';

@Component({
  selector: 'bepatient-eq5-slider-v3',
  templateUrl: './input-eq5-vertical-slider.component.html',
  styleUrls: ['./input-eq5-vertical-slider.component.scss'],
  standalone: false
})
export class InputEq5VerticalSliderV3
  extends QuestionBaseV3ComponentDirective
  implements DoCheck
{
  private sanitizer = inject(DomSanitizer);
  document = inject(DOCUMENT);

  @Input() question: Eq5QuestionV3;
  @Input() color: string;
  @Input() formGroup: UntypedFormGroup;
  dirty: boolean;

  @HostBinding('attr.style')
  get valueAsStyle(): any {
    return this.sanitizer.bypassSecurityTrustStyle(
      `--main-color: ${this.color}`
    );
  }

  get value() {
    return this.formGroup.get(this.question.key).value;
  }

  onChange(): void {
    this.formGroup.get(this.question.key).markAsTouched();
    this.dirty = this.formGroup.get(this.question.key).dirty;
  }

  ngDoCheck(): void {
    this.dirty = this.formGroup.get(this.question.key).dirty;
  }

  onInput(e): void {
    // Focus range slider on Input, triggered once when element is not focused.
    (e && e.target && e.target.focus()) || void 0;
    this.dirty = this.formGroup.get(this.question.key).dirty;
  }

  // To fix adding extra space in form when its in focus
  focusin(event: Event) {
    event.stopPropagation();
  }
}
